import { lazyNamed } from 'src/utils/lazyNamed';

export const Compliance = {
  Helmet: lazyNamed(() => import('./components/Helmet'), 'Helmet'),
  Layout: lazyNamed(() => import('./components/Layout'), 'Layout'),
  ListPriceChanges: lazyNamed(() => import('./pages/ListPriceChanges'), 'ListPriceChanges'),
  PositionFinancials: lazyNamed(() => import('./pages/PositionFinancials'), 'PositionFinancials'),
  AccountFinancials: lazyNamed(() => import('./pages/AccountFinancials'), 'AccountFinancials'),
  CreditNotes: lazyNamed(() => import('./pages/CreditNotes'), 'CreditNotes'),
};
